var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 42,
    viewBox: "0 0 49 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 39H27C36.9412 39 45 30.9411 45 21C45 11.0589 36.9412 3 27 3H2V39Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.847 26.307H16.4031C16.3404 26.3003 16.2808 26.2766 16.2306 26.2385C16.1804 26.2005 16.1416 26.1495 16.1182 26.091C16.0406 25.9285 16.0002 25.7506 16.0002 25.5705C16.0002 25.3904 16.0406 25.2125 16.1182 25.05C16.1422 24.992 16.1812 24.9415 16.2313 24.9037C16.2814 24.8659 16.3407 24.8421 16.4031 24.835H22.847C22.9095 24.8417 22.9691 24.8653 23.0193 24.9031C23.0695 24.941 23.1084 24.9918 23.1321 25.05C23.2096 25.2126 23.2499 25.3904 23.2499 25.5705C23.2499 25.7506 23.2096 25.9284 23.1321 26.091C23.1086 26.1494 23.0697 26.2004 23.0195 26.2384C22.9693 26.2764 22.9096 26.3002 22.847 26.307ZM26.6251 21.89H16.6251C16.5402 21.8882 16.4567 21.8679 16.3804 21.8306C16.3041 21.7933 16.2367 21.7399 16.1831 21.674C16.0651 21.5262 16.0007 21.3427 16.0007 21.1535C16.0007 20.9643 16.0651 20.7808 16.1831 20.633C16.2367 20.5671 16.3041 20.5137 16.3804 20.4764C16.4567 20.4391 16.5402 20.4188 16.6251 20.417H26.6251C26.7101 20.4185 26.7937 20.4386 26.8701 20.4759C26.9465 20.5132 27.0138 20.5669 27.0671 20.633C27.1859 20.7805 27.2506 20.9642 27.2506 21.1535C27.2506 21.3429 27.1859 21.5265 27.0671 21.674C27.0138 21.7402 26.9465 21.7937 26.8701 21.8311C26.7937 21.8684 26.7101 21.8885 26.6251 21.89ZM28.5131 17.472H16.7361C16.6394 17.4723 16.5436 17.4534 16.4543 17.4163C16.3651 17.3792 16.2841 17.3247 16.2161 17.256C16.1476 17.1877 16.0932 17.1066 16.0562 17.0173C16.0191 16.928 16 16.8322 16 16.7355C16 16.6388 16.0191 16.5431 16.0562 16.4537C16.0932 16.3644 16.1476 16.2833 16.2161 16.215C16.2842 16.1465 16.3653 16.0923 16.4546 16.0554C16.5439 16.0185 16.6395 15.9997 16.7361 16H28.5092C28.7044 16 28.8915 16.0776 29.0295 16.2156C29.1676 16.3536 29.2451 16.5408 29.2451 16.736C29.2451 16.9312 29.1676 17.1184 29.0295 17.2564C28.8915 17.3944 28.7044 17.472 28.5092 17.472H28.5131Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 49,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.2108399cac0d42314b56e5d64336b048.svg";
export { ForwardRef as ReactComponent };